import React from 'react'
import { useState,useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as PinIcon} from '../../../../images/icons/pin.svg'
import { ReactComponent as SoldIcon} from '../../../../images/icons/sold.svg'
import ApiUrl from '../../../../configTools/apiUrl'
import Reels from './reels'

const Listings = ({username}) => {
  const UserInfo = JSON.parse(localStorage.getItem("user-info"));
    const [products,setProducts] = useState([]);
    const [page,setPage] = useState(0);
    const [pin,setPin] = useState(false);
    const [sold,setSold] = useState(false);

    const togglePin = ()=>{
      setPin(!pin);
      setSold(false);
    }
    const toggleSold = ()=>{
      setSold(!sold);
      setPin(false);
    }

    const refresh_products = ()=>{
      fetch(ApiUrl.API_URL_ListingUser+"/"+username)
      .then(res=>res.json())
      .then(data =>{
          if(data.success)
          setProducts(data.responce);
      });
    }
    const change_pin = (id)=>{
      fetch(ApiUrl.API_URL_ListingPin+"/"+id,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
          refresh_products();
        }
      });
    }
    const change_sold = (id)=>{
      fetch(ApiUrl.API_URL_ListingSold+"/"+id,{
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
          refresh_products();
        }
      });
    }

  useEffect(() => {
    fetch(ApiUrl.API_URL_ListingUser+"/"+username)
    .then(res=>res.json())
    .then(data =>{
        if(data.success)
        setProducts(data.responce);
    });
  },[username])
  return (
    <div className='user_profile_bottom_container'>
      <div className='public_home_pagesswitch_container'>
          <div className={page === 0?'public_home_exploretab_container active':'public_home_exploretab_container'} onClick={
              ()=>{setPage(0);}
          }>
              <h5>Posts</h5>
          </div>
          <div className={page === 1?'public_home_feedtab_container active':'public_home_feedtab_container'} onClick={
              ()=>{setPage(1);}
          }>
              <h5>Reels</h5>
          </div>
          <div className={page === 2?'public_home_feedtab_container active':'public_home_feedtab_container'} onClick={
              ()=>{setPage(2);}
          }>
              <h5>Reviews</h5>
          </div>
      </div>
      {UserInfo !== null && UserInfo.username === username && page === 0 &&
        <div className='user_listing_pin_sold_switch'>
          <p>
            <b onClick={togglePin}>{!pin ? "Edit pin" : "Close pin editing"}</b>
            <b onClick={toggleSold}>{!sold ? "Edit sold" : "Close sold editing"}</b>
          </p>
        </div>
      }
      {page === 0 &&
        <div className='listing_container'>
          <div className='public_home_product_grid_1_container'>
            <div className='public_home_product_grid_4_products'>
              {pin === false && sold === false &&
                  products.map((product,index)=>{
                      return(
                          <div style={{width:String((100/(parseInt(3))))+"%", padding:"0.1%"}} key={index}>
                            <Link to={'/product/'+product.slug}>
                                <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+product.image})`}}>
                                    <div className='public_home_product_grid_1_products_item_overlay'>
                                        <div className='public_home_product_grid_1_products_item_overlay_price'>
                                            {product.sold === 0 &&
                                              <p>
                                                {product.compareatprice !== 0 && product.compareatprice !== undefined &&
                                                    <b>Rs.{product.compareatprice}/-</b>
                                                }
                                                Rs.{product.price}/-
                                              </p>
                                            }
                                            {product.sold !== 0 &&
                                              <p>
                                                Sold
                                              </p>
                                            }
                                        </div>
                                    </div>
                                    {product.pin !== 0 &&
                                    <div className='listing_activepin_overlay'>
                                      <div className='listing_active_pin_icon'>
                                        <PinIcon width={'40px'} height={'40px'} />
                                      </div>
                                    </div>
                                    }
                                    {product.sold !== 0 &&
                                    <div className='listing_activepin_overlay' style={{
                                      justifyContent:"flex-start"
                                    }}>
                                      <div className='listing_active_pin_icon'>
                                        <SoldIcon width={'40px'} height={'40px'} />
                                      </div>
                                    </div>
                                    }
                                </div>
                            </Link>
                          </div>
                      )
                  })
              }
              {pin === true && sold === false &&
                  products.map((product,index)=>{
                      return(
                          <div style={{width:String((100/(parseInt(3))))+"%", padding:"0.1%"}} key={index}>
                            <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+product.image})`}}>
                                <div className='listing_pin_overlay'>
                                  <button onClick={()=>{
                                    change_pin(product.id);
                                  }}>{product.pin === 0?"Pin on Top":"Unpin"}</button>
                                </div>
                            </div>
                          </div>
                      )
                  })
              }
              {pin === false && sold === true &&
                  products.map((product,index)=>{
                      return(
                          <div style={{width:String((100/(parseInt(3))))+"%", padding:"0.1%"}} key={index}>
                            <div className='public_home_product_grid_1_products_item_container' style={{backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+product.image})`}}>
                                <div className='listing_pin_overlay'>
                                  <button onClick={()=>{
                                    change_sold(product.id);
                                  }}>{product.sold === 0?"Mark Sold":"Mark Unsold"}</button>
                                </div>
                            </div>
                          </div>
                      )
                  })
              }
            </div>
          </div>
        </div>
      }
      {page === 1 &&
        <Reels username={username}/>
      }
      {page === 2 &&
        <div className='no_reviews_container' style={{
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          height:"300px"
        }}>
          <h3>No reviews yet.</h3>
        </div>
      }
    </div>
  )
}

export default Listings
